import uploadspracticeAreassidebysideimagethe_biggest_mass_tort_cases_in_historyJpg from "$lib/data/generated/uploads/practice areas/SideBySide/image/the_biggest_mass_tort_cases_in_history.jpg";

export const uploads = {
  "uploads/practice areas/SideBySide/image/the_biggest_mass_tort_cases_in_history.jpg": uploadspracticeAreassidebysideimagethe_biggest_mass_tort_cases_in_historyJpg
};